import axios from 'axios';
import cookieUtils from '../cookie/cookie-utils';
import acerillRestErrorHandler from './acerill-rest-error-handler';

const acerillAuthenticatedAxios = axios.create();
acerillAuthenticatedAxios.interceptors.request.use(
  config => {
    config.withCredentials = true;
    config.params = config.params || {};
    config.params.product = 'custom-forms';
    let csrfToken;
    if (['DELETE', 'PATCH', 'POST', 'PUT'].indexOf(config.method.toUpperCase()) >= 0 &&
      (csrfToken = cookieUtils.getCookie('csrf_token'))) {
      config.headers = config.headers || {};
      config.headers['X-CSRF-Token'] = csrfToken;
    }
    return config;
  },
  err => Promise.reject(err));
acerillAuthenticatedAxios.interceptors.response.use(
  response => response,
  acerillRestErrorHandler.handleRestError
);
export {acerillAuthenticatedAxios};

const acerillPublicAxios = axios.create();
acerillPublicAxios.interceptors.response.use(
  response => response,
  acerillRestErrorHandler.handleRestError
);
export {acerillPublicAxios};
